import React from 'react';
import { observer, inject } from 'mobx-react';
import SystemElement from '../fieldType/SystemElement';
import InputElement from '../fieldType/InputElement';
import TextareaElement from '../fieldType/TextareaElement';
import BrowserElement from '../fieldType/BrowserElement';
import CheckElement from '../fieldType/CheckElement';
import SelectElement from '../fieldType/SelectElement';
import FileElement from '../fieldType/FileElement';
import SpecialElement from  '../fieldType/SpecialElement';
import WeaFna from '../../asyncComps/WeaFna';
import LocationElement from '../fieldType/LocationElement';
import * as Util from '../../util/formUtil';
import * as FieldUtil from '../../util/public/fieldUtil';
import WfEncrypt from '../../public/wf-encrypt/index';
import * as _ from '../../util/public/common';
import * as DetailUtil from '../../util/public/detailUtil';
import ConflictDisplayPanel from './ConflictDisplayPanel';

@inject('globalStore', 'layoutStore')
@observer
export default class FileContent extends React.Component{
    componentWillMount(){
        const { symbol,cellObj,isDetail,rowIndex,layoutStore } = this.props;
        const fieldid = cellObj.field.toString();
        const fieldMark = isDetail ? `field${fieldid}_${rowIndex}` : `field${fieldid}`;
        layoutStore.initFieldObj(symbol, fieldMark);
    }
    componentDidUpdate(){
        const { symbol,rowIndex,cellObj } = this.props;
        const fieldid = cellObj.field.toString();
        if(symbol.indexOf("detail_") > -1)
            DetailUtil.syncLockedRowHeight(fieldid, rowIndex);
    }
    render() {
        const { symbol,cellObj,isDetail,rowIndex,globalStore,layoutStore } = this.props;
        const fieldid = cellObj.field.toString();
        const { JSComplete, conflictFieldMap } = globalStore;
        const { fieldAttrMap,mainData,detailMap,variableMap } = layoutStore;
        const fieldAttr = fieldAttrMap.get(fieldid);
        const fieldMark = isDetail ? `field${fieldid}_${rowIndex}` : `field${fieldid}`;
        const fontSize = _.get(cellObj, ["font", "font-size"]) || "9pt";
        const promptRequired = variableMap.get("promptRequiredField") === fieldMark;   //是否提示必填
        let showError = conflictFieldMap.has(fieldMark) && !conflictFieldMap.get(fieldMark).hasConfirm; //字段冲突显示提醒

        let fieldObj = null;
        let detailData = null;
        let rowInfo = null;
        let detailKeyid = -1;
        if(isDetail){
            if(isNaN(rowIndex))
                return <span>无效设置，明细字段需置于表头表尾标示之间行</span>
            const detailObj = detailMap.get(symbol);
            detailData = detailObj.detailData;
            rowInfo = detailObj.rowInfo.get(`row_${rowIndex}`);
            detailKeyid = rowInfo.get("keyid") || 0;
            fieldObj = FieldUtil.getDetailFieldObj(fieldMark, symbol)
        }else{
            fieldObj = FieldUtil.getMainFieldObj(fieldMark);
        }
        const { value,variable } = fieldObj;
        const forceRender = variable.has("forceRender") ? variable.get("forceRender") : "";     //仅为强制render
        //计算字段类型(支持动态切换字段类型)
        let htmltype = fieldAttr.htmltype || 0;
        let detailtype = fieldAttr.detailtype || 0;
        if(variable.has("changeFieldType") && variable.get("changeFieldType").indexOf("-")>0){
            const typeArr = variable.get("changeFieldType").split("-");
            htmltype = parseInt(typeArr[0]);
            detailtype = parseInt(typeArr[1]);
        }
        //当前字段的只读、必填属性
        const viewAttr = FieldUtil.getFieldCurViewAttr(fieldMark, fieldObj);
        if(viewAttr === -101)
            return <span>此为明细字段，被识别在主布局中，请调整模板解决</span>
        //字段值,特殊字符转换
        const fieldValue = FieldUtil.restoreSpeicalChar(fieldid, value.toString(), htmltype, detailtype, viewAttr);
        //拼接字段组件基础参数
       	const baseProps = {JSComplete, fieldid, rowIndex, isDetail, viewAttr, detailtype};
        baseProps.value = fieldValue;
        baseProps.fieldName  = fieldMark;
        baseProps.fieldlabel = fieldAttr.fieldlabel;
        baseProps.defaultFocus = promptRequired === true;
        baseProps.style = (htmltype === 2 && detailtype === 2) ? {} : {"font-size": fontSize};
        if(htmltype === 6){  //附件字段特殊处理(标签页切换过程中需要render附件组件)
            //const fileVisible = judgeFieldExistVisibleArea(conf, fieldid);
            const fileVisible = true;
            baseProps.display = fileVisible;
        }
        //财务模块组件
        const { fnaInfo } = layoutStore;
        if(fnaInfo.belFna === true && _.has(fnaInfo, ["fnaCompFields", fieldid])){
            const fnaParam = _.get(fnaInfo, ["fnaCompFields", fieldid]);
            const { baseParam,commonParam } = globalStore;
            const wfInfo = {...baseParam, ...{nodetype: commonParam.nodetype}};
            return (
                <WeaFna ecId={`${this && this.props && this.props.ecId || ''}_WeaFna@akicfb`} 
                    fieldid = {fieldid}
                    rowIndex = {rowIndex}
                    fnaParam = {fnaParam}   //后台接口封装的财务字段属性
                    wfInfo = {wfInfo}       //流程基础信息
                    fieldObj = {fieldAttr}    //字段信息
                    viewAttr = {viewAttr}
                    fieldValue = {fieldValue}
                    detailKeyid = {detailKeyid}
                />
            )
        }
        //判断是否加密组件
        if(fieldAttr.encryptFlag > 0){
            return <WfEncrypt value={fieldValue} fieldAttr={fieldAttr} fieldObj={fieldObj} />
        }
        const elementProps = {baseProps,fieldMark,fieldAttr,symbol,rowIndex,cellObj,fieldObj};
        const proxyProps = {fieldid, rowIndex, fieldMark, viewAttr, fieldValue, fieldValueObj:fieldObj};
        const getElement = () =>{
            let el = <span className="default"></span>;
            if(parseInt(fieldid) < 0){      //系统字段
                el = <SystemElement ecId={`${this && this.props && this.props.ecId || ''}_SystemElement@ixouin`} {...elementProps} />
            }else if(htmltype === 1){
                el = <InputElement ecId={`${this && this.props && this.props.ecId || ''}_InputElement@jmkms7`} {...elementProps} />
            }else if(htmltype === 2){
                el = <TextareaElement ecId={`${this && this.props && this.props.ecId || ''}_TextareaElement@xs3gug`} {...elementProps} />
            }else if(htmltype === 3){
                el = <BrowserElement ecId={`${this && this.props && this.props.ecId || ''}_BrowserElement@2mq6lm`} {...elementProps} />
            }else if(htmltype === 4){
                el = <CheckElement ecId={`${this && this.props && this.props.ecId || ''}_CheckElement@oyy2bn`} {...elementProps} />
            }else if(htmltype === 5){
                el = <SelectElement ecId={`${this && this.props && this.props.ecId || ''}_SelectElement@gubx9o`} {...elementProps} />
            }else if(htmltype === 6){
                el = <FileElement ecId={`${this && this.props && this.props.ecId || ''}_FileElement@nkmov4`} {...elementProps} />
            }else if(htmltype === 7){
                el = <SpecialElement ecId={`${this && this.props && this.props.ecId || ''}_SpecialElement@ajooer`} {...elementProps} />
            }else if(htmltype === 8){
            }else if(htmltype === 9){//位置字段
                el = <LocationElement ecId={`${this && this.props && this.props.ecId || ''}_LocationElement@a13n3v`} {...elementProps} />
            }
            return el;
        }
        const result = [];
        const proxyCompFn = WfForm.getCustomProxyCompFn(`FieldContent_${fieldid}`);
        if(proxyCompFn === null){
            const proxyComp = WfForm.renderCustomComp(fieldMark, viewAttr, 1, elementProps);
            const afterComp = WfForm.renderCustomComp(fieldMark, viewAttr, 2);
            result.push(proxyComp == null ? getElement() : proxyComp);
            if(afterComp !== null)
                result.push(afterComp);
        }else{
            result.push(proxyCompFn(proxyProps, getElement));
        }
        let content = (
          <React.Fragment>
            {
              showError ?  
                <div className='show-error'>
                    {result}
                </div> : result
            }
            { JSComplete && showError
              && <div 
                    className='error-icon-div' 
                    onClick={(event)=> {
                    event.stopPropagation();
                    this.handleConflict(event, fieldMark)
                }}>
                  <i className="icon-coms02-Warning" />
              </div>
            }
          </React.Fragment>
        )

        return content;
    }

    handleConflict = (event, fieldMark) => {
      const { globalStore } = this.props;
      const { conflictFieldMap } = globalStore;
      let fieldData = conflictFieldMap.get(fieldMark) && conflictFieldMap.get(fieldMark);
      let pos = {posX: event.pageX, posY: event.pageY};
      let panel = document.getElementById('conflict-panel-box');
      let str = '';
      if(!panel) {
        panel = document.createElement('div');
        panel.setAttribute('id', 'conflict-panel-box');
        document.body.appendChild(panel);
      } else {
        $('#conflict-panel-box').css({visibility: 'visible'});
      }
      if(fieldData.specialObj) {
        str += fieldData.specialobj && fieldData.specialobj[0].name || ''; //浏览按钮值拼成文本串
      } else {
        str += fieldData.value;
      }
      ReactDOM.render( 
        <ConflictDisplayPanel 
          clickPos={pos} 
          onOk={this.onOk.bind(this,fieldMark)} 
          onCancel={this.onCancel.bind(this, fieldMark)}
          content={str}
        />, 
        panel
      );
    }

    onOk = (fieldMark) => {
      const { globalStore } = this.props;
      const { conflictFieldMap,changeConflictFieldMap } = globalStore;
      let fieldData = conflictFieldMap.get(fieldMark);
      WfForm.changeFieldValue(fieldMark, fieldData);
      changeConflictFieldMap({[fieldMark]: {...fieldData, hasConfirm: true}});
    }


    onCancel = (fieldMark) => {
      const { globalStore } = this.props;
      const { changeConflictFieldMap,conflictFieldMap } = globalStore;
      let fieldData = conflictFieldMap.get(fieldMark);
      changeConflictFieldMap({[fieldMark]: {...fieldData, hasConfirm: true}});
    }
} 


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/components/layout/FieldContent.js